<template>
    <div class="caseApply">
        <!-- <div class="caseApplyHead">
            <div class="caseApplyTitle">病案复印助手</div>
        </div> -->
        <div class="caseApplyFourthTitle" v-if="myOrderDesc.srv_type==='2'">
            <div class="caseApplyFourthLogo"></div>
            <div class="caseApplyFourthTxt">
                <span>复印人:{{myOrderDesc.address.name}}</span>
                <span class="phoneNum">{{myOrderDesc.address.tel}}</span>
                <p>
                    {{myOrderDesc.address.stateName+myOrderDesc.address.cityName+myOrderDesc.address.districtName+myOrderDesc.address.subdistrict}}</p>
            </div>
        </div>
        <ul>
            <li class="caseApplyMessage" style="margin-left:0.2rem;">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">申请信息:</span>
                    <van-icon name="arrow"/>
                    <span class="chooseHospital" @click="selectMore" ref="openMore">{{openMore}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-show="descFlag">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">申请编号</span>
                    <span class="chooseHospital1">{{myOrderDesc.order_id}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-show="descFlag">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">{{hospitalNoLabel}}</span>
                    <span class="chooseHospital1">{{myOrderDesc.hospitalNo}}</span>
                </div>
            </li>
            <li class="caseApplyMessage">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">申请状态</span>
                    <span class="chooseHospital" v-if="myOrderDesc.status=='0'">未支付</span>
                    <span class="chooseHospital" v-if="myOrderDesc.status=='2'">已取消</span>
                    <span class="chooseHospital" v-if="myOrderDesc.status=='4'">已支付</span>
                    <span class="chooseHospital" v-if="myOrderDesc.status=='5'">通过审核</span>
                    <span class="chooseHospital" v-if="myOrderDesc.status=='6'">审核未通过</span>
                    <span class="chooseHospital" v-if="myOrderDesc.status=='8'">支付中</span>
                    <span class="chooseHospital" v-if="myOrderDesc.status=='9'">待补款</span>
                    <span class="chooseHospital" v-if="myOrderDesc.status=='10'">已补款</span>
                </div>
            </li>
            <li class="caseApplyMessage">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">就诊医院</span>
                    <span class="chooseHospital1">{{myOrderDesc.org_name}}</span>
                </div>
            </li>
            <li class="caseApplyMessage">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">就诊患者</span>
                    <span class="chooseHospital1">{{myOrderDesc.consumer_name}}</span>
                </div>
            </li>
            <li class="caseApplyMessage">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">{{dateTimeLabel}}</span>
                    <span class="chooseHospital1">{{getTimeDesc(myOrderDesc.dis_time)}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-if="myOrderDesc.srv_type==='2'">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">快递名称</span>
                    <span class="chooseHospital1">{{myOrderDesc.express_name}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-if="myOrderDesc.srv_type==='2'">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">快递单号</span>
                    <span class="chooseHospital1" @click="selectExpressMsg">{{myOrderDesc.express_code}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-if="myOrderDesc.srv_type==='3'">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">自提码</span>
                    <span class="chooseHospital1">{{myOrderDesc.express_code}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" style="margin-left:0.2rem;">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">复印用途:</span>
                </div>
            </li>
            <li class="caseApplyMessage">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle"
                          v-if="myOrderDesc.copyFlag===0">{{getCopyType(myOrderDesc.copy_type)}}</span>
                    <span class="IDCardTitle" v-if="myOrderDesc.copyFlag===1">{{myOrderDesc.copy_type}}</span>
                    <span class="chooseHospital1">{{myOrderDesc.amount}}份</span>
                </div>
            </li>
            <li class="caseApplyMessage" style="margin-left:0.2rem;">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">支付详情:</span>
                    <van-icon name="arrow"/>
                    <span class="chooseHospital" @click="priceMore" ref="openMore1">{{openMore}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-show="priceMoreFlag">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle1">复印费用（预收）</span>
                    <span class="chooseHospital">{{myOrderDesc.yffy}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-show="priceMoreFlag">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle1">邮寄费用</span>
                    <span class="chooseHospital">{{myOrderDesc.yjfy}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" v-show="priceMoreFlag">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle1">服务费用</span>
                    <span class="chooseHospital">{{myOrderDesc.fwfy}}</span>
                </div>
            </li>
            <li class="caseApplyMessage" style="margin-left:0.2rem;">
                <div class="caseApplyTypeNav">
                    <span class="IDCardTitle">支付金额:</span>
                    <span class="chooseHospital">{{myOrderDesc.totalMoney}}</span>
                </div>
            </li>
        </ul>
        <div class="caseApplyFooter" v-if="myOrderDesc.status == '0' || myOrderDesc.status == '9'">
            <input type="button" :value="btnName" :disabled="btnFlag" @click="payMoney" :class="btnFlag?'':'btnactive'">
        </div>
    </div>
</template>
<script>
    import {Toast} from 'vant'
    import ApiSetting from '@/assets/js/api'
    import tool from '@/assets/js/tool'

    export default {
        data() {
            return {
                descFlag: false,
                priceMoreFlag: false,
                myOrderDesc: '',
                orderId: '',
                openMore: '查看更多',
                closeMore: '收起',
                btnName: '',
                btnFlag: false,
                orderEndTime: '',//应为支付超时结束时间
                orderStartTime: '',//应为接口获取到的保存订单时间
                contentTime: '',
                hospitalNoLabel:'住院号', //如果是门诊，此处改为就诊卡号
                dateTimeLabel:'出院时间' //如果是门诊，此处改为就诊时间
            }
        },
        created() {
            this.myOrderDesc = JSON.parse(sessionStorage.getItem('myOneOrder'))
            this.orderId = this.myOrderDesc.order_id
            var timeStr = this.myOrderDesc.created_time.replace(/-/g, "/")
            console.info("timeStr:::1:", timeStr)
            if ('9' == this.myOrderDesc.status) { // 补缴不设置超时时间，每次进来都是最新的倒计时30分钟
                this.orderStartTime = new Date().getTime()
                console.info("timeStr:::2:", this.orderStartTime)
            } else {
                this.orderStartTime = new Date(timeStr).getTime()
                console.info("timeStr:::3:", this.orderStartTime)
            }
            this.orderEndTime = this.orderStartTime + 30 * 60 * 1000
            if (this.orderEndTime <= new Date().getTime()) {
                //支付超时，不能支付
                this.btnName = '支付超时'
                this.btnFlag = true
            } else {
                this.btnFlag = false
                this.countDown()
            }
            if (this.myOrderDesc.case_type == '6') {
                this.hospitalNoLabel = '就诊卡号';
                this.dateTimeLabel = '就诊时间';
            }
        },
        methods: {
            selectExpressMsg() {
                this.$router.push({path: '/expressMsg'})
            },
            countDown() {
                var clock = window.setInterval(() => {
                    var date = this.orderEndTime - new Date().getTime(); //计算剩余的毫秒数
                    if (date <= 0) {
                        //支付超时，不能支付
                        this.btnName = '支付超时';
                        this.btnFlag = true;
                        clearInterval(clock);
                    } else {
                        var day = parseInt(date / 1000 / 60 / 60 / 24, 10);
                        var hour = parseInt(date / 1000 / 60 / 60 % 24, 10);
                        if (hour < 10) {
                            hour = "0" + hour
                        }
                        var min = parseInt(date / 1000 / 60 % 60, 10);//计算剩余的分钟
                        if (min < 10) {
                            min = "0" + min
                        }
                        var ss = parseInt(date / 1000 % 60, 10);//计算剩余的秒数
                        if (ss < 10) {
                            ss = "0" + ss
                        }
                        this.btnName = min + '分' + ss + '秒后超时，去支付'
                    }
                }, 1000)
            },
            getCopyType(val) {
                if (val === '7') {
                    return '医保报销（含病理）'
                } else if (val === '8') {
                    return '医保报销（不含病理）'
                } else if (val === '9') {
                    return '病理报告'
                } else if (val === '10') {
                    return '化验单'
                } else if (val === '11') {
                    return '全部病案'
                } else if (val === '21') {
                    return '保险';
                } else if (val === '22') {
                    return '农合意外';
                } else if (val === '23') {
                    return '本地医保';
                } else if (val === '24') {
                    return '外地医保';
                } else if (val === '25') {
                    return '慢性病';
                } else if (val === '26') {
                    return '特殊病';
                } else if (val === '27') {
                    return '工伤鉴定';
                } else if (val === '28') {
                    return '出生证';
                } else if (val === '29') {
                    return '外出看病';
                } else if (val === '30') {
                    return '事故科';
                } else if (val === '31') {
                    return '派出所';
                } else if (val === '32') {
                    return '低保';
                } else if (val === '33') {
                    return '法院';
                } else if (val === '34') {
                    return '病退';
                } else if (val === '35') {
                    return '贫困';
                }
            },
            getTimeDesc(str) {
                let date = new Date(str)
                let year = date.getFullYear()
                let month = date.getMonth() + 1
                let day = date.getDate()
                if (month < 10) {
                    month = '0' + month
                }
                if (day < 10) {
                    day = '0' + day
                }
                return year + '-' + month + '-' + day
            },
            payMoney() {
                var param = {
                    orderId: this.orderId
                }
                this.postRequest(ApiSetting.pay, param).then((res) => {
                    console.info("res.data:::" + res.data)
                    if (res.data.responseCode == '200') {
                        console.info("res.data:::000")
                        tool.gotoPay(
                            res.data.data.appId,
                            res.data.data.timeStamp,
                            res.data.data.nonceStr,
                            res.data.data.orderPackage,
                            res.data.data.signType,
                            res.data.data.paySign,
                            res.data.data.orderNo
                        )
                        console.info("tool.gotoPay:::")
                    } else if (res.data.responseCode == '0') {
                        console.info("tool.gotoPay:::11")
                        Toast.fail('获取支付签名失败，' + res.data.msg)
                    } else {
                        console.info("tool.gotoPay:::22")
                        Toast.fail('获取支付签名失败')
                    }
                })

            }
            ,
            selectMore() {
                if (this.descFlag) {
                    this.descFlag = false
                    this.$refs.openMore.innerText = this.openMore
                } else {
                    this.descFlag = true
                    this.$refs.openMore.innerText = this.closeMore
                }
            }
            ,
            priceMore() {
                if (this.priceMoreFlag) {
                    this.priceMoreFlag = false
                    this.$refs.openMore1.innerText = this.openMore
                } else {
                    this.priceMoreFlag = true
                    this.$refs.openMore1.innerText = this.closeMore
                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .caseApplyFourthTitle {
        background: #fff;
        color: #333333;
        border-bottom: 1px solid #e4e4e4;
        font-size: 0.28rem;
        width: 100%;
        height: auto;
        overflow: hidden;

        .caseApplyFourthLogo {
            width: 0.88rem;
            height: 0.88rem;
            margin-top: 0.16rem;
            display: inline-block;
            float: left;
            margin-right: 0.2rem;
            margin-left: 0.2rem;
            background: url('../assets/images/headerImg.png') no-repeat;
            background-size: 100%;
        }

        .caseApplyFourthTxt {
            span {
                display: inline-block;
                height: 0.6rem;
                line-height: 0.6rem;
            }

            p {
                height: 0.6rem;
                line-height: 0.6rem;
                margin: 0;
                width: 6rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;
            }

            .phoneNum {
                float: right;
                margin-right: 0.2rem;
                color: #999999;
            }
        }

    }

    .caseApplyHead {
        border-bottom: 1px solid #e4e4e4;
    }

    .van-cell {
        padding: 0;
        padding-left: 0.2rem;
        height: 0.8rem;
        line-height: 0.8rem;

        /deep/
        .van-field__button {
            padding-right: 0.2rem !important;
        }

        .van-button--primary {
            color: #fff;
            background-color: #1C84F2;
            border: 1px solid #1C84F2;
            border-radius: 0.1rem;
        }
    }

    ul {
        background: #fff;
        clear: both;

        li {
            margin-left: 0.4rem;
        }
    }

    .caseApplyTypeNav {
        padding-left: 0;

        .chooseHospital1 {
            float: right;
            margin-right: 0.2rem;
            font-size: 0.28rem;
            color: #999999;
        }

        .van-icon {
            margin-right: 0.2rem;
            font-size: 0.28rem;
            color: #1C84F2;
            float: right;
            top: 0rem !important;
            height: 1rem;
            line-height: 0.92rem;
        }

        .chooseHospital {
            float: right;
            margin-right: 0.2rem;
            font-size: 0.28rem;
            color: #1C84F2;
        }

        .IDCardTitle {
            display: inline-block;
            color: #333333;
        }

        .IDCardTitle1 {
            display: inline-block;
            color: #1C84F2;
        }

        .van-icon {
            position: relative;
            top: 0.04rem;
        }

    }
</style>

